/* WhatsApp forms.

   One handler for every form that hands off to WhatsApp. A form opts in with
   data-whatsapp-surface="<surface>" and, optionally, a [data-whatsapp-status]
   element for the reply.

   Both surfaces that exist today — the home page's experience switcher and the
   consultation page's booking form — used to be separate submit handlers that only
   called preventDefault and printed a thank-you. They now share this, so the request
   is rendered and recorded server-side once, in one place.

   The endpoint returns a wa.me link. It also writes the submission to the lead log
   before responding, because WhatsApp never tells us whether the customer pressed
   send (audit 14.6), so a booking is never lost even if they abandon the chat.
*/

(() => {
  if (window.CaratKinWhatsappForms) return;
  window.CaratKinWhatsappForms = true;

  const t = window.CaratKinStrings || {};

  async function submit(form) {
    const button = form.querySelector("[type='submit']");
    const status = form.querySelector("[data-whatsapp-status]");
    const original = button?.textContent;

    if (button) {
      button.disabled = true;
      button.textContent = t.whatsappOpening || "Opening WhatsApp…";
    }
    if (status) status.textContent = "";

    try {
      const response = await fetch("/apps/cart-kin/whatsapp/message", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          surface: form.dataset.whatsappSurface,
          fields: Object.fromEntries(new FormData(form).entries()),
          pageUrl: window.location.href,
        }),
      });
      if (!response.ok) throw new Error(`WhatsApp link request failed: ${response.status}`);

      const payload = await response.json();
      if (!payload.link) throw new Error("No WhatsApp link returned");

      form.reset();
      window.open(payload.link, "_blank", "noopener");
    } catch (error) {
      console.error(error);
      const message = t.whatsappFailed || "Could not open WhatsApp — please try again";
      // Prefer the design's own status line; fall back to the button when a form has none.
      if (status) status.textContent = message;
      else if (button) button.textContent = message;
      return;
    } finally {
      if (button) {
        button.disabled = false;
        if (button.textContent === (t.whatsappOpening || "Opening WhatsApp…")) {
          button.textContent = original;
        }
      }
    }

    if (button) button.textContent = original;
  }

  document.addEventListener("submit", (event) => {
    const form = event.target.closest("form[data-whatsapp-surface]");
    if (!form) return;
    event.preventDefault();
    submit(form);
  });
})();
